import React from 'react';
import Helmet from 'react-helmet';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { buttonWrapper } from '../utilities/LaborSafetyNotify';
import {
  PageTitle,
  CompanyStatus,
  AccordionToggle,
} from '../components/LaborSafetyComponents';

/**
 * @description 施工体系台帳作成建設工事の通知 詳細ページコンポーネント
 */
// eslint-disable-next-line no-unused-vars
export const ConstructionWorkNotifyDetail = ({ vw }) => (
  <div className='master-slide-view show'>
    <Helmet>
      <title>{HEADER_CONSTANTS.rouan} - 施工体系台帳作成建設工事の通知</title>
    </Helmet>

    <div className='master-slide-view__view'>
      <div className='setting-main'>
        <div
          className='labor-safety-main__header labor-safety-constsys-ledger-notify__header'
          style={{ pointerEvents: 'all' }}
        >
          <PageTitle title='施工体系台帳作成建設工事の通知' />
        </div>
        <Header />
        <div className='labor-safety-body labor-safety-constsys-ledger-notify-body'>
          {/* <object
            data="http://www.africau.edu/images/default/sample.pdf"
            type="application/pdf"
            width="100%"
            height="100%"
          /> */}
        </div>
      </div>
    </div>
  </div>
);

/**
 * @description 設定ヘッダーメニュー
 */
const Header = () => {
  return (
    <div
      id='labor-safety-header'
      className='labor-safety-header labor-safety-constsys-ledger-notify-header'
    >
      <HeaderButtons />
      <CompanyStatus />
    </div>
  );
};

const HeaderButtons = buttonWrapper(({ onExcel, onPDF, onCreateComplete }) => (
  <div className='labor-safety-header__item labor-safety-constsys-ledger-notify-header__item'>
    <ul className='btn-menu labor-safety-constsys-ledger-notify__header-buttons'>
      <li className='btn-menu__item'>
        <button className='btn' onClick={onExcel}>
          Excelで出力
        </button>
      </li>

      <li className='btn-menu__item'>
        <button className='btn' onClick={onPDF}>
          PDFで出力
        </button>
      </li>

      <li className='btn-menu__item'>
        <button className='btn' onClick={onCreateComplete}>
          作成完了
        </button>
      </li>
      <AccordionToggle />
    </ul>
    <div>
      <span className='labor-safety-constsys-ledger-notify-header__text'>
        ※工事情報確認・編集画面に遷移します。
      </span>
      <button className='btn--sub'>編集画面に遷移</button>
    </div>
  </div>
));



// WEBPACK FOOTER //
// ./src/pages/ConstructionWorkNotifyDetail.jsx